import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ModalController } from '@ionic/angular/standalone';
import { Observable, from, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EulaService } from '../services/eula.service';
import { EulaModalComponent } from '../components/eula-modal/eula-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EulaGuard implements CanActivate {
  constructor(
    private eulaService: EulaService,
    private modalController: ModalController,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.eulaService.checkEULAStatus().pipe(
      switchMap(status => {
        console.log('EULA Status Check:', status);
        
        if (status.hasAcceptedEULA) {
          // User has already accepted EULA, allow access
          console.log('User has already accepted EULA, allowing access');
          return of(true);
        } else {
          // User hasn't accepted EULA, show modal
          console.log('User has not accepted EULA, showing modal');
          return this.showEULAModal();
        }
      }),
      catchError(error => {
        console.error('Error checking EULA status:', error);
        // On error, allow access to prevent blocking the app
        return of(true);
      })
    );
  }

  private showEULAModal(): Observable<boolean> {
    return from(this.presentEULAModal()).pipe(
      switchMap(result => {
        if (result.accepted) {
          // User accepted EULA, allow access
          return of(true);
        } else {
          // User declined EULA, redirect to logout
          this.router.navigate(['/login']);
          return of(false);
        }
      }),
      catchError(error => {
        console.error('Error showing EULA modal:', error);
        // On error, allow access to prevent blocking the app
        return of(true);
      })
    );
  }

  private async presentEULAModal(): Promise<{ accepted: boolean }> {
    const modal = await this.modalController.create({
      component: EulaModalComponent,
      componentProps: {},
      backdropDismiss: false,
      keyboardClose: false,
      cssClass: 'eula-modal'
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    return data || { accepted: false };
  }
} 